import { ArrowUp } from 'lucide-react';

interface SectionProps {
  id: string;
  backgroundImage: string;
  children: React.ReactNode;
  showBackToTop?: boolean;
  backToTopColor?: 'text-white' | 'text-black';
  className?: string;
  overlayClassName?: string;
  onBackToTop?: () => void;
}

const Section: React.FC<SectionProps> = ({
  id,
  backgroundImage,
  children,
  showBackToTop = true,
  backToTopColor = 'text-white',
  className = '',
  overlayClassName = 'bg-black/20',
  onBackToTop,
}) => {
  const handleBackToTop = () => {
    const element = document.getElementById('top');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    if (onBackToTop) {
      onBackToTop();
    }
  };

  return (
    <section
      id={id}
      className={`relative min-h-screen flex items-center py-12 md:py-0 ${className}`}
    >
      {showBackToTop && (
        <button
          onClick={handleBackToTop}
          className={`absolute top-2 md:top-4 left-1/2 transform -translate-x-1/2 ${backToTopColor} hover:text-gray-300 transition-colors z-10`}
        >
          <ArrowUp className="w-8 h-8 md:w-12 md:h-12" />
        </button>
      )}
      
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      />
      
      <div className={`absolute inset-0 ${overlayClassName}`} />
      
      <div className="relative z-10 container mx-auto px-4 md:px-6">
        {children}
      </div>
    </section>
  );
};

export default Section;
